import type { ComponentProps } from 'react';

import { Image } from '@change-corgi/design-system/components/media';
import { Html } from '@change-corgi/design-system/html';
import { Flex } from '@change-corgi/design-system/layout';
import { Heading } from '@change-corgi/design-system/typography';

import { useJoinTheCommunity } from './hooks/useJoinTheCommunity';

export function JoinTheCommunity(props: ComponentProps<typeof Flex>) {
	const {
		data: { displayed, heading, text },
	} = useJoinTheCommunity();

	if (!displayed) return null;

	return (
		<Flex
			sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
			data-qa="join-the-community"
			{...props}
		>
			<Image mb={40} sx={{ height: 80 }} src="https://static.change.org/psf/contribution-hand.png" alt="" />
			<Heading size={['h3', 'h2']} as="h2" mb={16}>
				{heading}
			</Heading>
			<Html as="div" html={text} size="large" sx={{ maxWidth: 380 }} />
		</Flex>
	);
}
